import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { AppointmentService } from 'projects/Administration/src/app/business-services/appointment.service';
import { WorkOrderStatus } from '../../../../../../../Autofacets-Core/src/app/utils/enums';
import { AppointmentList, DemandListDownload } from '../../../../business-entities/appointmentList-model';
import { PdfType } from '../../../../business-entities/appointmentPdfType-model';
import { EditAppointmentService } from '../../../../business-services/edit-appointment.service';
import { PDFViewComponent } from './pdf-view/pdf-view.component';
import { CookieService } from 'ngx-cookie-service';
import { AppointmentServiceDetails } from 'projects/Administration/src/app/business-entities/appointment-service-details-view-model';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-pdf-appointment-order',
  templateUrl: './pdf-appointment-order.component.html'
})

export class PDFAppointmentOrderComponent implements OnInit {
  @Input() isDownloadOrder: boolean = false;
  pdfTypeList: PdfType[];
  pdfType: PdfType[] = [];
  @ViewChild(PDFViewComponent) childComponent: PDFViewComponent;
  appointmentDetails: AppointmentList;
  serviceDetail: AppointmentServiceDetails;
  SelectedPayer: any = [];
  pdfToolTip: string;
  groupedDemandList: DemandListDownload[];
  documentTypeId: number = 0;
  dropdownSettings = {
    singleSelection: false,
    idField: 'customerNo',
    textField: 'customerNo',
    selectAllText: 'Select All',
    unSelectAllText: 'UnSelect All',
    itemsShowLimit: 5,
    allowSearchFilter: false,
    searchPlaceholderText: 'Search here',
    maxHeight: 500
  };
  isWithoutPrice: boolean = false;
  constructor(private activeModal: NgbActiveModal,
    private appointmentService: AppointmentService,
    public editAppointmentService: EditAppointmentService,
    private cookieservice: CookieService,
    private spinner: NgxSpinnerService,
    private translate: TranslateService) { }

  ngOnInit(): void {
    this.appointmentDetails = this.editAppointmentService.appointmentDetails;
    this.appointmentService.pdfTypeIndex = 0;
    this.appointmentService.billToCustomerNo = this.SelectedPayer;
    this.appointmentService.documentTypeId = this.documentTypeId;
    if (this.isDownloadOrder) {

      this.GetServiceDetail();
    } else {
      this.GetAllPdfType();
    }

  }

  async GetServiceDetail() {
    this.spinner.show();
    this.groupedDemandList = [];
    const languageCode = this.cookieservice.get('userSelectedLanguage');
    await this.appointmentService.GetServiceDetail(this.editAppointmentService.appointmentDetails.id, '', languageCode).then(data => {
      this.spinner.hide();
      this.pdfToolTip = this.translate.instant("lblPrint");
      if (data.responseObject?.errorCount > 0) {
        this.serviceDetail = {
          totalPrice: 0,
          totalTime: 0,
          totalInvoicePrice: 0,
          priceForDisply: '',
          rentalCompanyMakeName: '',
          appointmentDemandList: [],
          appointmentJobDetailList: [],
          appointmentJobList: [],
          appointmentPriceDetails: [],
          isFromArchive: false
        }
        this.SelectedPayer = null;
        this.appointmentService.billToCustomerNo = this.SelectedPayer;
      }
      else if (data.responseObject != null && data.responseObject.appointmentDemandList.length > 0) {
        this.groupedDemandList = this.mapData(data.responseObject.appointmentDemandList);
        if(this.groupedDemandList.length == 1){
          this.SelectedPayer = this.groupedDemandList;
          this.appointmentService.billToCustomerNo = this.SelectedPayer[0].customerNo;
        }else{
          if(this.appointmentService.documentTypeId == 1){
            this.SelectedPayer = this.groupedDemandList;
            this.appointmentService.billToCustomerNo = this.SelectedPayer[0].customerNo;
          }else{
            this.SelectedPayer = [];
            this.appointmentService.billToCustomerNo = null;
          }
         
        }
      }
    })
  }

  mapData(data: any) {
    let supperArray = [];
    if (data && data.length > 0) {
      data.forEach(element => {
        if(!supperArray.find(x=>x.customerNo == element.billToCustomer))
        {
          let single = Object();
          single.customerNo = element.billToCustomer
          supperArray.push(single);
        }
      })
    }
    return supperArray;
  }

  GetAllPdfType() {
    this.appointmentService.GetPdfType().then(data => {
      this.pdfTypeList = data.responseObject;
      for (let i = 0; i < this.pdfTypeList.length; i++) {
        if (this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.InvoiceReady
          || this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.InvoicePaid ||
          this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.Closed) {
          if (i === 3) {
            this.pdfType.push(this.pdfTypeList[i]);
          }
          this.pdfToolTip = this.translate.instant("lblDownloadInvoice");
        }
        else if (this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.WorkRequest) {
          if (i === 2) {
            this.pdfType.push(this.pdfTypeList[i]);
          }
          this.pdfToolTip = this.translate.instant("lblDownloadOffer");
        }
        else if (this.appointmentDetails.workOrderStatusId.toString() === WorkOrderStatus.WorkDone) {
          if (i === 0 || i === 1) {
            this.pdfType.push(this.pdfTypeList[i]);
          }
          this.pdfToolTip = this.translate.instant("lblDownloadOrderConfirmation");
        }
      }
    })
  }

  onViewInvoice() {
    this.childComponent.ngOnInit();
  }

  OnChange(event: any) {
    this.pdfType.forEach(element => {
      if (element.type === event.target.value) {
        this.appointmentService.pdfTypeIndex = element.id;
      }
    });
  }

  OnPayerChange(event: any, isSelected: boolean) {
    if (isSelected) {
        this.appointmentService.billToCustomerNo = this.appointmentService.billToCustomerNo != null ? this.appointmentService.billToCustomerNo + ',' + event.customerNo : event.customerNo;
    } else {
        const customerNo = this.appointmentService.billToCustomerNo.split(',');
        this.appointmentService.billToCustomerNo = customerNo.filter(cn => cn !== event.customerNo).join(',');
    }
  }

  onSelectAllPayer(items: any, isSelected: boolean) {
    if(isSelected)
    {
      items.forEach(element => {
        this.appointmentService.billToCustomerNo = this.appointmentService.billToCustomerNo != null ? this.appointmentService.billToCustomerNo += ',' + element.customerNo : element.customerNo;
      })
    }
    else{
      this.appointmentService.billToCustomerNo = '';
    }
  }

  OnClose() {
    this.appointmentService.pdfTypeIndex = 0;
    this.appointmentService.billToCustomerNo = null;
    this.activeModal.close({ success: false });

  }
  OnDocumentTypeChange(value: any) {
    this.appointmentService.documentTypeId = value;
    if(value == 0)
    {
      this.appointmentService.billToCustomerNo = null;
      this.GetServiceDetail();
    }
    else{
      this.appointmentService.billToCustomerNo = this.groupedDemandList.length > 0? this.groupedDemandList[0].customerNo :null;
    }
  }
}
